<template><div></div></template>

<script setup lang="ts">
import { createVNode, getCurrentInstance, onMounted, render } from "vue";

import { type Newsletter } from "@/types/newsletter";

import CTAContainer from "./CTAContainer.vue";
import type { SubscriberFacingAuthentication } from "./SubscribeForm/lib";

const props = defineProps<{
  newsletter: Newsletter;
  subscriberFacingAuthentication: SubscriberFacingAuthentication;
}>();

const SELECTORS = [".header-navigation-link--subscribe"];

onMounted(() => {
  SELECTORS.forEach((selector) => {
    const ctaElements = document.querySelectorAll(selector);
    ctaElements.forEach((ctaElement: Element) => {
      // Replace it with an empty shell.
      const parent = ctaElement.parentElement;
      if (!parent) {
        return;
      }
      Array.from(parent.children).forEach((child: Element) => {
        if (child !== ctaElement) {
          return;
        }
        child.remove();
      });
      const newElement = document.createElement("div");
      parent.appendChild(newElement);

      const vnode = createVNode(CTAContainer, {
        newsletter: props.newsletter,
        subscriberFacingAuthentication: props.subscriberFacingAuthentication,
      });
      vnode.appContext = getCurrentInstance()?.appContext || null;
      render(vnode, newElement);
    });
  });
});
</script>
